import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import DynamicForm, { type DynamicFormSchema } from '@/common/components/DynamicForm/DynamicForm';

export default function CityForm() {

    const policyFormSchema: DynamicFormSchema = {
        layout: 'vertical', // Overall form layout
        showResetButton: true, // Show a reset button

        // Define form sections for better organization and complex layouts
        sections: [
            {
                key: 'City',
                title: 'City',
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [                  
                    {
                        name: 'name',
                        label: 'Name',
                        type: 'input',
                        required: true,
                        colSpan: 12,
                    }
                ],
            },
        ]

    };

    return (
        <DynamicForm
            schema={policyFormSchema}
            getByIdApiUrl={API_ENDPOINTS.LOOKUP.GET_CITY_BY_ID}
            updateApiUrl={API_ENDPOINTS.LOOKUP.UPDATE_CITY}
            refreshTableDataKey={QUERY_KEYS.LOOKUP.CITY}
        />
    );
}
